import * as React from 'react';
import { UserLight } from '../../../models';
import { FilterStore } from '../../../stores';
import { observer, inject } from 'mobx-react';
import { PVAMultiSelect } from './PVAMultiSelect';

interface PVAUserMultiSelectProps {
    defaultOptions?: any[];
    options: UserLight[];
    selected: number[];
    onChange: Function;
    FilterStore?: FilterStore;
    disabled?: boolean;
}

@inject('FilterStore') @observer
export class PVAUserMultiSelect extends React.Component<PVAUserMultiSelectProps, {}> {
    private sortUsers(a: UserLight, b: UserLight): number {
        if (a.lastName > b.lastName) {
            return 1;
        } else if (a.lastName < b.lastName) {
            return -1;
        }
        if (a.firstName > b.firstName) {
            return 1;
        } else if (a.firstName < b.firstName) {
            return -1;
        }

        return 0;
    }

    render() {
        return (
            <div>
                <PVAMultiSelect
                    {...this.props}
                    itemLabel="Team Members"
                    sortOptions={this.sortUsers}
                    renderOption={(user: UserLight) => (
                        <span>
                            {user.lastName}, {user.firstName}
                            {user.resultsArePrivate && <span> (Private)</span>}
                        </span>
                    )}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAUserMultiSelect.tsx